import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  ResolvedService,
  ServiceActivityStatus,
  ServiceActivityStatusTranslationMap,
  ServiceOperationalStatus,
} from '@wilson/interfaces';

@Component({
  selector: 'wilson-service-status',
  templateUrl: './service-status.component.html',
  styleUrls: ['./service-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServiceStatusComponent {
  @Input() set service(service: ResolvedService) {
    this._service = service;
    this.setActivityStatusBadgeBackgrondColor(service);
    this.setOperationalStatusBadgeBackgrondColor(service);
  }
  get service(): ResolvedService {
    return this._service;
  }

  public ServiceActivityStatus = ServiceActivityStatus;
  public ServiceActivityStatusTranslationMap =
    ServiceActivityStatusTranslationMap;
  public activityStatusBgColor: string;
  public ServiceOperationalStatus = ServiceOperationalStatus;
  public operationalStatusBgColor: string;
  public tooltipTitle: string = null;

  private _service: ResolvedService;

  setActivityStatusBadgeBackgrondColor(service: ResolvedService) {
    const status = service?.activityStatus;
    if (status === ServiceActivityStatus.StaffAssigned) {
      this.activityStatusBgColor = 'badge-primary-dark';
    } else if (status === ServiceActivityStatus.AssignedToShift) {
      this.activityStatusBgColor = 'badge-warning';
    } else if (status === ServiceActivityStatus.NotStaffed) {
      this.activityStatusBgColor = 'badge-danger';
    }
  }

  setOperationalStatusBadgeBackgrondColor(service: ResolvedService) {
    const status = service?.operationalStatus;
    if (status === ServiceOperationalStatus.NotStarted) {
      this.operationalStatusBgColor = 'badge-primary';
    } else if (status === ServiceOperationalStatus.DelayWarning) {
      this.operationalStatusBgColor = 'badge-warning';
      this.tooltipTitle = `service.operational_status.${status}.tooltip`; // show tooltip info for dalay warning since lable is only warning
    } else if (status === ServiceOperationalStatus.Ongoing) {
      this.operationalStatusBgColor = 'badge-primary-dark';
    } else if (status === ServiceOperationalStatus.Delayed) {
      this.operationalStatusBgColor = 'badge-danger';
    } else if (status === ServiceOperationalStatus.OngoingWarning) {
      this.operationalStatusBgColor = 'badge-warning';
      this.tooltipTitle = `service.operational_status.${status}.tooltip`; // show tooltip info for ongoing warning since lable is only warning
    } else if (status === ServiceOperationalStatus.Completed) {
      this.operationalStatusBgColor = 'badge-secondary-dark';
    } else if (status === ServiceOperationalStatus.Incomplete) {
      this.operationalStatusBgColor = 'badge-secondary';
    }
  }
}
